import * as MutationTypes from './mutation-types'

const mutations = {
  [MutationTypes.SET_NAME_CLIENT]: (state, payload) => {
    state.nameClient = payload
  },
}

export default mutations
